'use client';

import React, { createContext, useContext, useState } from "react";

// Создаем контекст
const ModalContext = createContext();

// Провайдер для управления состоянием модального окна
export const ModalProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    return (
        <ModalContext.Provider value={{ isOpen, openModal, closeModal }}>
            {children}
        </ModalContext.Provider>
    );
};

// Хук для использования контекста
export const useModal = () => useContext(ModalContext);
